import { Modal } from "../../modal";
import {
  GoogleMap,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import moment from "moment";
import "moment-timezone";
import { useCallback, useEffect, useState } from "react";
import latlngMarker from "../../../assets/latlng_marker.png";
import { TrackerRelationshipsService } from "../../../services/trackerRelationships";
import { NotificationManager } from "react-notifications";

moment.tz.setDefault("America/Sao_Paulo");

export const MapModal = ({ open, handleOnClose, latlng, updatedAt, vehicleSelected }) => {
  const [activeMarker, setActiveMarker] = useState(null);
  const [latLngData, setLatlngData] = useState();
  const [map, setMap] = useState(null);
  const trackerRelationshipsService = new TrackerRelationshipsService();
  const [markers, setMarkers] = useState([]);

  const onLoad = useCallback(function callback(map) {
    setMap(map);
  }, []);
  const onUnmount = useCallback(function callback(map) {
    setMap(null);
  }, []);


  const clearMarkers = () => {
    markers.forEach(marker => marker.setMap(null));
    setMarkers([]);
  };

  const handleMouseOver = (index) => {
    setActiveMarker(index);
  };

  const handleMouseOut = () => {
    setActiveMarker(null);
  };
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const getLatLong = () => {
    trackerRelationshipsService
      .getLatLong(vehicleSelected)
      .then((res) => {
        setLatlngData(res.data);
      })
      .catch((error) => {
        console.error(error);
        NotificationManager.error("Erro obtendo posições do veículo.", "", 3000);
      });
  };

  useEffect(() => {
    if (vehicleSelected != undefined && open == true && map) {
      getLatLong();
    }

  }, [open, map]);

  useEffect(() => {
    if (latLngData && latLngData.length > 0 && map) {
      clearMarkers();
      const newMarkers = latLngData.map((latlng) => {
        return new window.google.maps.Marker({
          position: latlng,
          map,
          optimized: true,
          icon: {
            url: latlngMarker,
            origin: new window.google.maps.Point(0, 0),
            anchor: new window.google.maps.Point(0, 10),
            scaledSize: new window.google.maps.Size(6, 6),
          },
        });
      });
      setMarkers(newMarkers);
    }
  }, [latLngData, map]);

  return (
    <Modal
      showBackArrow
      open={open}
      onClose={handleOnClose}
      title="Localização"
    >
      <Box style={{ height: "480px" }}>
        <GoogleMap
          id="map"
          mapContainerClassName="map-container"
          mapContainerStyle={{ width: "100%", height: "100%" }}
          center={latlng}
          onLoad={onLoad}
          onUnmount={onUnmount}
          zoom={15}
        >
          <Marker
            title={"Última Posição do Veículo"}
            position={latlng}
          />


        </GoogleMap>
        <Typography
          style={{ float: "right", marginTop: "-2px", fontSize: "13px" }}
          component="span"
          variant="body2"
        >
          Atualizado em {moment(updatedAt).format("DD/MM/YYYY HH:mm:ss")}
        </Typography>
      </Box>
    </Modal>
  );
};
